import {
  Box,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Radio,
  RadioGroup,
} from '@mui/material'
import React from 'react'
import { Controller, RegisterOptions, useFormContext } from 'react-hook-form'
import { useTranslation } from '../../hooks'
import { BoxWithLabel } from '../BoxWithLabel'

type GenderFieldsControllerProps = {
  name?: string
  label?: string
  rules?: RegisterOptions
}

const FieldWithController: React.FC<GenderFieldsControllerProps> = ({
  name = 'gender',
  rules,
}) => {
  const { t } = useTranslation()

  const {
    formState: { errors },
    control,
  } = useFormContext()

  return (
    <FormControl error={!!errors.gender}>
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field }) => (
          <RadioGroup {...field}>
            <Box display="flex">
              <FormControlLabel
                value="f"
                control={<Radio />}
                label={t('patients:genders.f')}
              />
              <FormControlLabel
                value="m"
                control={<Radio />}
                label={t('patients:genders.m')}
              />
            </Box>
          </RadioGroup>
        )}
      />
      <FormHelperText>{errors.gender?.message as string}</FormHelperText>
    </FormControl>
  )
}

export const GenderFieldsController: React.FC<GenderFieldsControllerProps> = ({
  label,
  ...props
}) => {
  return label ? (
    <BoxWithLabel label={label} required={!!props.rules?.required}>
      <FieldWithController {...props} />
    </BoxWithLabel>
  ) : (
    <FieldWithController {...props} />
  )
}
